export default __webpack_public_path__ + "static/media/no-permission.8c43cac5.svg";